import { formatBuyLinkExpireDateKo } from "./buyLinkExpiry";

type PaymentLinkMessageRequest = Record<string, unknown>;

export const buildPaymentLinkMessage = (
  request: PaymentLinkMessageRequest = {}
): string => {
  const paymentUrl = String(request.paymentUrl || "").trim();
  if (!paymentUrl) return "";
  const itemName = String(request.itemName || "결제 요청").trim() || "결제 요청";
  const amount = Number(request.amount) || 0;
  const customerName = String(request.customerName || "").trim();
  const greeting = customerName ? `${customerName}님, ` : "";
  const expireDateText =
    String(request.requestType || "").toUpperCase() === "BUYLINK"
      ? formatBuyLinkExpireDateKo(request.urlExpireDate)
      : "";
  return [
    "[CNFOOD 카드결제 안내]",
    `${greeting}${itemName} ${amount.toLocaleString("ko-KR")}원 결제입니다.`,
    "아래 링크를 눌러 결제를 진행해 주세요.",
    ...(expireDateText ? [`유효기간: ${expireDateText}까지`] : []),
    paymentUrl,
    "",
    "[결제 방법]",
    "1. 사용하실 카드사를 선택해 주세요.",
    "2. 카드사 앱 설치가 어렵다면 화면에 표시되는 ‘앱 없이 결제’, ‘일반결제’ 또는 ‘결제코드 보기’ 중 가능한 방법을 선택해 주세요. 카드사마다 메뉴 이름이 다를 수 있습니다.",
    "3. 카드사 인증 후에는 원래 결제 화면으로 돌아와 ‘결제 완료’ 화면까지 꼭 확인해 주세요.",
    "",
    "※ 카드번호·비밀번호·CVC를 영업담당자에게 문자나 사진으로 보내지 마세요.",
    "※ 완료 여부가 불분명하면 중복 결제하지 말고 담당자에게 먼저 문의해 주세요.",
  ].join("\n");
};

export const buildPaymentCopyPreview = (
  request: PaymentLinkMessageRequest = {},
  kind = "LINK"
) => {
  const isMessage = kind === "MESSAGE";
  return {
    kind: isMessage ? "MESSAGE" : "LINK",
    title: isMessage ? "문자 문구 미리보기" : "결제 링크 미리보기",
    text: isMessage
      ? buildPaymentLinkMessage(request)
      : String(request.paymentUrl || "").trim(),
  };
};
